import { Object3D } from "three";
import { MeshInfo } from "../../Meshes/MeshInfo";

export class InsideElementObject extends Object3D {
 
    constructor() {
        super();   
    }
}

export class MeshInsideElementObject extends InsideElementObject {

    public MeshInfo?: MeshInfo;
}